.root {
  position: relative;
}

// Highlights the trigger when at least one popover filter is active.
.root-is-active button {
  border-color: var(--color-primary);
  color: var(--color-primary-foreground);
}

.root-badge {
  margin-left: 6px;
}

.root-backdrop {
  background: transparent;
  border: 0;
  cursor: default;
  inset: 0;
  position: fixed;
  z-index: 99;
}

.root-panel {
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  gap: 12px;
  left: 0;
  // Cap height so the panel never spills past the viewport on short screens
  // (e.g. MacBook Air). The reserved space accounts for the toolbar/trigger
  // above; remaining content scrolls instead of getting clipped.
  max-height: calc(100vh - 240px);
  max-width: calc(100vw - 24px);
  min-width: 280px;
  overflow-y: auto;
  padding: 12px;
  position: absolute;
  top: calc(100% + 6px);
  z-index: 100;
}

.root-panel-end {
  left: auto;
  right: 0;
}
